import Vue from 'vue';
import Vuex from 'vuex';
//import createPersistedState from 'vuex-persistedstate';
import { getField, updateField } from 'vuex-map-fields';
import service from '../data/service';
//import { v4 as uuidv4 } from 'uuid';


Vue.use(Vuex)

//Modules

const store = new Vuex.Store({
  plugins: [
    //createPersistedState({})
  ],
  getters: {
    getField,
  },

  state: {
    dialogSave: false,
    dialogTxt: 'save',
    // selections
    civicAssociations: [
      "Alcova Heights Citizens Association",
      "Arlington East Falls Church Association",
      "Arlington Forest Citizens Association",
      "Arlington Heights Civic Association",
      "Arlington Mill Civic Association (formerly Columbia Heights West)",
      "Arlington Ridge Civic Association",
      "Arlington View Civic Association",
      "Arlingwood Neighborhood Association",
      "Ashton Heights Civic Association",
      "Aurora Highlands Civic Association",
      "Ballston-Virginia Square Civic Association",
      "Barcroft School and Civic League",
      "Bellevue Forest Citizens'  Association",
      "Bluemont Civic Association",
      "Boulevard Manor Civic Association",
      "Buckingham Community Civic Association",
      "Chain Bridge Forest Civic Association",
      "Cherry Valley Nature Center",
      "Cherrydale Citizens Association",
      "Claremont Citizens Association",
      "Clarendon-Courthouse Civic Association",
      "Colonial Village Civic Association",
      "Columbia Forest Civic Association",
      "Columbia Heights Civic Association",
      "Crystal City Civic Association",
      "Dominion Hills Civic Association",
      "Donaldson Run Civic Association",
      "Douglas Park Civic Association",
      "Dover-Crystal Civic Association",
      "Fairlington Citizens Association",
      "Forest Glen Civic Association",
      "Foxcroft Heights Civic Association",
      "Glebewood Civic Association",
      "Glencarlyn Civic Association",
      "Green Valley Civic Association (Nauck)",
      "Gulf Branch Civic Association",
      "Highland Park-Overlee Knolls Civic Association",
      "John M. Langston Citizens Association",
      "Leeway Overlee Civic Association",
      "Long Branch Creek Civic Association",
      "Lyon Park Citizens Association",
      "Lyon Village Citizens Association",
      "Madison Manor Civic Association",
      "Maywood Community Association",
      "North Highlands Citizens' Association",
      "North Rosslyn Civic Association",
      "Old Dominion Citizens Association",
      "Old Glebe Civic Association",
      "Penrose Neighborhood Association",
      "Radnor/Ft. Myer Heights Civic Association",
      "Rivercrest Civic Association",
      "Riverwood Civic Association",
      "Rock Spring Civic Association",
      "Shirlington Civic Association",
      "Stafford-Albemarle-Glebe Civic Association",
      "Tara-Leeway Heights Civic Association",
      "Waverly Hills Civic Association",
      "Waycroft-Woodlawn Civic Association",
      "Westover Village Civic Association",
      "Williamsburg Civic Association",
      "Woodmont Civic Association",
      "Yorktown Civic Association"
    ],
    nonprofit: [
      "Yes, religious organization",
      "Yes, other",
      "No"
    ],
    states: service.states(),
    yesNoString: [
      "Yes",
      "No"
    ],
    singleOrSeries: [
      "Single",
      "Series"
    ],
    calendarTopics: [ //service.getTopics(),
      'Animals',
      'Art',
      'Board Meeting',
      'Budget',
      'Business',
      'Classes',
      'Commissions',
      'Community Events',
      'Environment',
      'Family Services',
      'Fitness',
      'Health',
      'Housing',
      'Jobs',
      'Library',
      'Payments',
      'Real Estate Assessments',
      'Schools',
      'Sports',
      'Taxes',
      'Transportation',
      'Trash & Recycling',
      'Volunteer',
      'Voting',
      'Public Meeting',
      'Cultural/Educational',
      'Live Music Performance',
      'Seasonal/Holiday',
      'Amazon'
    ],
    acgTabs: [
      { tab: "Intro" },
      { tab: "Submitter" },
      { tab: "General" },
      { tab: "Event Mgr" },
      { tab: "Sponsor" },
      { tab: "Financial" },
      { tab: "Safety" },
      { tab: "Publicity" },
      { tab: "Site" },
      { tab: "Waste" },
      { tab: "Parking" },
      { tab: "Restrooms" },
      { tab: "Location" },
      { tab: "Signage" },
      { tab: "Food" },
      {
        tab: "Agreement",
      },
      { tab: "Print"}
    ],

    /*       { tab: "Intro" },
      { tab: "General Event" },
      { tab: "Event Manager Information" },
      { tab: "Sponsor Information" },
      { tab: "Financial Information" },
      { tab: "Public Safety and Security" },
      { tab: "Event Publicity" },
      { tab: "Site Information" },
      { tab: "Special Event Trash and Recycling" },
      { tab: "Parking" },
      { tab: "Restroom Facilities" },
      { tab: "Location Impact" },
      { tab: "Signage & Advertising" },
      { tab: "Food Services & Beverages" },
      {
        tab: "Arlington County Special Event Application Hold Harmless Agreement",
      },
      { tab: "Submitter Section" }, */

    // data
    data: {
      id: undefined,
      SEA_Title: null,
      SEA_Location: null,
      SEA_CivicAssociation: null,
      SEA_Summary: null,
      SEA_Vision: null,
      SEA_PreviouslyHeld: null,
      SEA_PreviousDate: null,
      SEA_PreviousSponsor: null,
      SEA_PreviousLocation: null,
      SEA_IsThisaSingle: null,
      SEA_SetupTime: null,
      SEA_EventStartTime: null,
      SEA_EventEndTime: null,
      SEA_BreakdownTime: null,
      SEA_SeriesSetupTime: null,
      SEA_SeriesStartTime: null,
      SEA_SeriesEndTime: null,
      SEA_SeriesBreakdownTime: null,
      SEA_AttendeesMin: null,
      SEA_AttendeesMax: null,
      SEA_ManagerNameFirst: null,
      SEA_ManagerNameLast: null,
      SEA_ManagerEmail: null,
      SEA_EventContactPhone: null,
      SEA_Nonprofit: null,
      SEA_SponsorNameFirst: null,
      SEA_SponsorNameLast: null,
      SEA_SponsorEmail: null,
      SEA_SponsorContactPhone: null,
      SEA_SponsorAddress1: null,
      SEA_SponsorAddress2: null,
      SEA_SponsorAddressCity: "Arlington",
      SEA_SponsorAddressState: "VA",
      SEA_SponsorAddressZIP: null,
      SEA_PreviousGrossRevenue: null,
      SEA_PreviousCost: null,
      SEA_PreviousCharges: null,
      SEA_EstimatedGrossRevenue: null,
      SEA_EstimatedTotalExpense: null,
      SEA_FeeReductionAward: null,
      SEA_PSS_Extreme: null,
      SEA_PSS_StreetClosures: null,
      SEA_PSS_ClosureArea: null,
      SEA_PSS_ClosureAreaDesc: null,
      SEA_PSS_Checkpoints: null,
      SEA_PSS_Hazardous: null,
      SEA_PSS_HazardousPurpose: null,
      SEA_PSS_KnownThreats: null,
      SEA_PSS_SecurityStaff: null,
      SEA_PSS_Sound: null,
      SEA_PSS_SoundDesc: null,
      SEA_PSS_Overnight: null,
      SEA_PSS_Assemblage: null,
      SEA_Certificate_ANIRequired_1: null,
      SEA_Animals: null,
      SEA_Certificate_INSRequired_2: null,
      SEA_Insurance: null,
      SEA_InsuranceName: null,
      SEA_License: null,
      SEA_Public: null,
      SEA_Publicized: null,
      SEA_CalendarDescription: null,
      SEA_FreeOrPaid: null,
      SEA_EventFee: null,
      SEA_Topics: null,
      SEA_IsThisaFamilyFriendly: null,
      SEA_MinimumAge: null,
      SEA_MaximumAge: null,
      SEA_PublicContactNameFirst: null,
      SEA_PublicContactNameLast: null,
      SEA_PublicContactEmail: null,
      SEA_PublicContactPhone: null,
      SEA_Website: null,
      SEA_MobileStage: null,
      SEA_PlanUpload: null,
      SEA_PlanURL: null,
      SEA_Tents: null,
      SEA_Permit_OCCRequired_5: null,
      SEA_Permit_BUILDRequired_6: null,
      SEA_AmusementDevices: null,
      SEA_AmusementDeviceDesc: null,
      SEA_Permit_ElectricalRequired_11: null,
      SEA_Permit_ElectricalNotes_11: null,
      SEA_WaterStation: null,
      SEA_StreetSweeping: null,
      SEA_WasteDisposalPlan: null,
      SEA_WasteTypeQual: null,
      SEA_WasteCompostableMaterials: null,
      SEA_WasteVolunteer: null,
      SEA_WasteTrashColl: null,
      SEA_WasteReduction: null,
      SEA_IsParkingAvailable: null,
      SEA_ParkingOffsite: null,
      SEA_ParkingOffsiteDesc: null,
      SEA_ParkingShuttleOpt: null,
      SEA_ParkingDesc: null,
      SEA_Restrooms: null,
      SEA_RestroomInsideMale: null,
      SEA_RestroomInsideFemale: null,
      SEA_RestroomInsideHandicap: null,
      SEA_RestroomOutsideMale: null,
      SEA_RestroomOutsideFemale: null,
      SEA_RestroomOutsideHandicap: null,
      SEA_RestroomHandWashing: null,
      SEA_RestroomContracting: null,
      SEA_DIS_Bool: null,
      SEA_DIS_Parking: null,
      SEA_DIS_List: [],
      SEA_Signage: null,
      SEA_SignageLocDesc: null,
      SEA_FoodBeverage: null,
      SEA_FoodAlcohol: null,
      SEA_FoodService: null,
      SEA_FoodVendorNum: null,
      SEA_Signature: null,
      SEA_SubmitterFirst: null,
      SEA_SubmitterLast: null,
      SEA_SubmitterEmail: null,
      SEA_SubmitterPosition: null,
      events: [],
      uploadedFiles: [],
      disabled: false,
      signature: null,
      attest: null,
      specialEventId: null,
    },
  },
  actions: {
    //
  },
  mutations: {
    updateField,
    setDraftFields(state, value) {
      //console.log({ setDraftFields: value });
      state.data = value;
    },
    setDocId(state, value) {
      //console.log({ setDocId: value });
      state.data.id = value;
    },
    setDialogSave(state, value) {
      state.dialogSave = value;
    },
    setDialogTxt(state, value) {
      state.dialogTxt = value;
    },
  },
  modules: {
    //
  },
})

export default store;